import script from "./Call.vue?vue&type=script&setup=true&lang=js"
export * from "./Call.vue?vue&type=script&setup=true&lang=js"

import "./Call.vue?vue&type=style&index=0&id=0d9d924c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d9d924c"]])

export default __exports__